import { Localization } from "@viamap/viamap2-common";
import { useContext, useState, createContext, useRef } from "react";
import { Button } from "react-bootstrap";
import { FileImportOptions, FileImportType, ParsedFile } from "./FileImportHooks";
import { GlassInfoButton } from "./GlassButtons";
import { FileLoader } from "./FileLoader";

export const FileImportContext = createContext<FileImporterContext>({ importState: {}, importCallBack: () => { } })
FileImportContext.displayName = "FileImportContext";

export default function FileImporter(props: { children: JSX.Element | JSX.Element[] }) {
  let fileWindow = useRef(null);
  let tempFileImportOptions = useRef<FileImportOptions | null>(null)

  const [fileImportOptions, setFileImportOptions] = useState<FileImportOptions | null>(null)

  function handleCallbacks(fileOptions: FileImportOptions) {
    switch (fileOptions.fileImportType) {
      case FileImportType.FileExplore:
        if (fileWindow.current) {
          tempFileImportOptions.current = fileOptions;
          (fileWindow.current as any).click();
        }
        return;
      case FileImportType.FileFetch:
        if (fileOptions.url) {
          setFileImportOptions(fileOptions)
        }
        break;
      case FileImportType.ImportFiles:
      case FileImportType.Drop:
        if (fileOptions.files) {
          setFileImportOptions(fileOptions)
        }
        break;
      default:
        throw new Error("Error FileImportType: " + fileOptions.fileImportType)
        break;
    }
  }

  function handleEvents(a: React.ChangeEvent<HTMLInputElement>) {
    if (tempFileImportOptions.current && a.target.files) {
      let fileOptions = tempFileImportOptions.current

      handleCallbacks({
        ...fileOptions,
        files: a.target.files,
        fileImportType: FileImportType.ImportFiles,
      })
    }
  }

  function handleFinish() {
    setFileImportOptions(null);
    if (fileWindow.current) {
      (fileWindow.current as any).value = null;
    }
  }

  return (
    <FileImportContext.Provider value={{ importState: "A", importCallBack: handleCallbacks }} >
      <FileLoader fileImportOptions={fileImportOptions || null} finishCallback={handleFinish} />
      {props.children}
      <input ref={fileWindow} style={{ display: "none" }} type="file" id="fileImporter" multiple onChange={(event) => handleEvents(event)} />
    </FileImportContext.Provider>
  )
}

type FileImporterContext = {
  importState: any,
  importCallBack: (fileOptions: FileImportOptions) => void,
}

export function SimpleImportButton() {
  let { importCallBack: importCB } = useContext(FileImportContext)
  return (

    <button
      className='GlassButton'
      style={{ float: "right", display: "inline-block", height: "32px" }}
      onClick={() => { importCB({ fileImportType: FileImportType.FileExplore }) }}
    >
      {Localization.getText("Add Layer")}
    </button>
  )
}

export function ImportButton() {
  let { importCallBack: importCB } = useContext(FileImportContext)

  const [value, setValue] = useState("Click Me")

  function handleSucces(file: ParsedFile) {
    setValue(file.meta.name)
  }

  return <Button style={{ position: "relative", zIndex: 90000 }} onClick={() => { importCB({ fileImportType: FileImportType.FileExplore, callBackSuccess: handleSucces }) }}>{value}</Button>
}

export function DropZone(props: { active: boolean, children?: any }) {
  let { importCallBack: importCB } = useContext(FileImportContext)
  let elementRef = useRef<HTMLDivElement>(null);

  if (!props.active) {
    return props.children;
  }

  return (
    <div ref={elementRef} className="DropZone" data-dropzone={Localization.getText("Drop files here")}
      onDragEnter={(event) => {
        event.preventDefault();

      }}
      onDragLeave={(event) => {
        event.preventDefault();
        console.log(event.target);
        elementRef.current?.classList.remove("dragging")
      }}
      onDragOver={(e) => {
        e.preventDefault()
        elementRef.current?.classList.add("dragging")
      }}
      onDrop={(event) => {
        event.preventDefault();
        event.stopPropagation();
        console.log(event.target);
        elementRef.current?.classList.remove("dragging")
        let files = event.dataTransfer.files;
        if (files) {
          importCB({ fileImportType: FileImportType.ImportFiles, files });
          return false
        }
      }}
    >
      {props.children}
    </div>
  )
}

export function AlertClick() {
  let { importCallBack: importCB } = useContext(FileImportContext)

  return (
    <GlassInfoButton onClick={() => { importCB({ fileImportType: FileImportType.FileExplore }) }} >
      <span style={{ fontSize: "16px", fontWeight: "semibold" }}>{Localization.getText("Add Layer")}</span><br />
      <span style={{ fontSize: "10px", fontWeight: "semibold" }}>{Localization.getText("Drag and Drop")}</span>
    </GlassInfoButton>
  )
}
